// v4: Recursive TOC node structure (max 4 levels)
// Can be either an article or a folder containing more nodes
export default class TOCNode {
  public type = 'article'; // 'article' | 'folder'
  public contentId?: string; // For articles
  public label?: string; // For folders
  public order = 0;
  public expanded?: boolean; // For folders (expansion state)
  public items?: TOCNode[]; // Recursive nesting (max 4 levels)
}
